var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_903_45036)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.6641 0.00195312H3.33267C1.49207 0.00195312 0 1.49403 0 3.3346C0 4.43894 0.895257 5.33419 1.9996 5.33419H13.9972C15.0498 5.34703 15.9285 4.53376 15.9968 3.48322C16.077 1.64256 14.6499 0.0853426 12.8093 0.00510874C12.7609 0.00298417 12.7125 0.00195312 12.6641 0.00195312Z",
    fill: "#3A8636"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6637 6.66602H1.33303C0.964913 6.66602 0.666504 6.96442 0.666504 7.33254V12.6648C0.668691 14.5045 2.15948 15.9953 3.99915 15.9975H11.9975C13.8372 15.9953 15.328 14.5045 15.3302 12.6648V7.33254C15.3302 6.96442 15.0318 6.66602 14.6637 6.66602ZM9.99794 9.99869H5.99874C5.63063 9.99869 5.33222 9.70028 5.33222 9.33217C5.33222 8.96405 5.63063 8.66564 5.99874 8.66564H9.99794C10.3661 8.66564 10.6645 8.96405 10.6645 9.33217C10.6645 9.70028 10.3661 9.99869 9.99794 9.99869Z",
    fill: "#3A8636"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_903_45036"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrder);
export default __webpack_public_path__ + "static/media/order.8a31403aaa5ad9e198399573a0ecab1d.svg";
export { ForwardRef as ReactComponent };